import {
  Component,
  ElementRef,
  input,
  InputSignal,
  ViewChild,
  AfterViewInit,
  effect,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { EventCardComponent } from '../event-card/event-card.component';
import { RouterLink } from '@angular/router';
import { EventSkeletonComponent } from '../event-skeleton/event-skeleton.component';
import { EventModel } from '../../models';

@Component({
  selector: 'hypenation-tickets-featured-events-carousel',
  standalone: true,
  imports: [
    CommonModule,
    EventCardComponent,
    RouterLink,
    EventSkeletonComponent,
  ],
  templateUrl: './featured-events-carousel.component.html',
  styleUrl: './featured-events-carousel.component.css',
})
export class FeaturedEventsCarouselComponent implements AfterViewInit {
  @ViewChild('scrollContainer') scrollContainer!: ElementRef;

  public readonly events: InputSignal<Array<EventModel>> = input<
    Array<EventModel>
  >([]);
  public readonly loading: InputSignal<boolean> = input<boolean>(false);

  public canScrollLeft = false;
  public canScrollRight = false;

  constructor() {
    // Watch for changes in events and check scroll position after content loads
    effect(() => {
      if (this.events().length > 0) {
        // Use setTimeout to ensure DOM is updated
        setTimeout(() => this.checkScrollPosition(), 100);
      }
    });
  }

  ngAfterViewInit() {
    this.checkScrollPosition();
  }

  scrollLeft() {
    if (this.scrollContainer) {
      const container = this.scrollContainer.nativeElement;
      container.scrollBy({ left: -300, behavior: 'smooth' });
      setTimeout(() => this.checkScrollPosition(), 300);
    }
  }

  scrollRight() {
    if (this.scrollContainer) {
      const container = this.scrollContainer.nativeElement;
      container.scrollBy({ left: 300, behavior: 'smooth' });
      setTimeout(() => this.checkScrollPosition(), 300);
    }
  }

  checkScrollPosition() {
    if (this.scrollContainer) {
      const container = this.scrollContainer.nativeElement;
      this.canScrollLeft = container.scrollLeft > 0;
      this.canScrollRight =
        container.scrollLeft < container.scrollWidth - container.clientWidth;
    }
  }
}

